import * as commonModule from './common';

const searchKeyword = (element, keyword) => {
  // Regular expression to strip html tags
  const stripHtmlTag = /(<([^>]+)>)/ig;
  // Setting the search text by stripping html tags and replacing html elements with space and converting to lowercase
  // (This is done to add space between text() of different tags which otherwise will come together)
  const searchText = $(element).map((_,el) => { return $(el).html().replace(stripHtmlTag, ' '); }).get().join(' ').toLowerCase();
  // Added match conditions - the search text must start with keyword or end with keyword
  // (This is to avoid searching keywords in between words in seach text)
  const matchCondition = searchText.includes(` ${keyword}`) || searchText.includes(`${keyword} `);
  return matchCondition ? true : false;
};

const filterFeaturesPerFeatureCategory = (collapsedFeaturesList, openFeaturesList, searchTerm) => {
  // Iterating on all the features in a section
  openFeaturesList.filter((index) => {
    const currentCollapsedFeature = $(collapsedFeaturesList[index]);
    const currentOpenFeature = $(openFeaturesList[index]);
    // Show/hide the collapsed features(only heading) according to
    currentCollapsedFeature.toggle(searchKeyword(currentOpenFeature, searchTerm));

    // Show/hide the open features(Heading + Sub-para) if it contains the serach term keyword
    currentOpenFeature.toggle(searchKeyword(currentOpenFeature, searchTerm));
  });
};

const liveSearch = (featureCategoriesList, featureCategoriesOriginalState, featureSearchInput) => {
  featureSearchInput.on('keyup', commonModule.debounce((event) => {
    const searchTerm = $(event.currentTarget).val().toLowerCase();
    // Show/hide the no-result-found div
    if (!searchKeyword(featureCategoriesList, searchTerm)) {
      $('.no-result-found').removeClass('d-none');
    } else {
      $('.no-result-found').addClass('d-none');
    }

    // Re-initializing featureCategoriesList to its original state for dealing with empty search term
    featureCategoriesList = (searchTerm === '') ? featureCategoriesOriginalState : featureCategoriesList;
    
    if (searchTerm === '') {
      $('.search-box .close-btn').hide();
    } else {
      $('.search-box .close-btn').show();
    }

    if (searchTerm === '') {
      $('.circles-left-right-bg-v2, .feature-sublist-description-list .bullet-points, .dots-bg').show().addClass('d-flex');
    } else {
      $('.circles-left-right-bg-v2, .feature-sublist-description-list .bullet-points, .dots-bg').hide().removeClass('d-flex');
    }

    // Iterating on the feature-category sections
    $(featureCategoriesList).each((_,element) => {
      // Checking if the section's text contains the search term
      // IF yes, then iterate on its features, ELSE hide this section & move on to next section
      if (searchKeyword($(element), searchTerm)) {
        // Storing all the features in collapsed state (showing only headings) in an array
        const collapsedFeaturesList = $(element).find('.feature-collapse');

        // Storing all the features in open state (showing headings + their descriptions) in an array
        const openFeaturesList = $(element).find('.feature-open');

        // Filtering features in current feature-category section
        filterFeaturesPerFeatureCategory(collapsedFeaturesList, openFeaturesList, searchTerm);

        // Showing the particular feature-category section if it contains the search term keyword
        $(element).toggle(searchKeyword($(element), searchTerm));
      } else {
        // Show/hide the section accordingly
        $(element).toggle(searchKeyword($(element), searchTerm));
      }
    });
  }, 500));
};

// Get feature-category sections in an array
const featureCategoriesList = $('.feature-category');
// set feature search to a variable
const featureSearchInput = $('#feature-search');

const searchFilter = () => {
  // Storing featureCategoriesList's original state
  const featureCategoriesOriginalState = featureCategoriesList;

  // Perform Live search on the features
  liveSearch(featureCategoriesList, featureCategoriesOriginalState, featureSearchInput);

  // Populate search input after clicking feature suggestion terms on features page
  $('.feature-suggestion-term').click((event) => {
    const featureSuggestionTerm = $(event.currentTarget).text();
    featureSearchInput.val(featureSuggestionTerm);
    featureSearchInput.keyup();
  });
};

const clearSearchItem = () => {
  featureSearchInput.val('');
  featureSearchInput.keyup();
};

window.clearSearchItem = clearSearchItem;

export {
  searchFilter
};